//自定义组件

import groupTree from "../components/common/groupTree.vue";
import userTree from "../components/common/userTree.vue";
import reportTop from "../../node_modules/common/src/components/sys/reportTop";
import reportTools from "../components/common/reportTools";
import carTool from "../components/common/carTool";
import personTool from "../components/common/personTool";
import payTool from "../components/common/payTool";
import timeTool from "../components/common/timeTool";
import selectGroup from "../components/common/selectGroup.vue";
import selectUser from "../components/common/selectUser.vue";
import selectCar from "../components/common/selectCar.vue";
import selecAlotCCar from "../components/common/selecAlotCCar.vue";
import selectPerson from "../components/common/selectPerson.vue";
import selectItems from "../components/common/selectItems.vue";
import selectGrid from "../components/common/selectGrid.vue";
import selectFence from "../components/common/selectFence.vue";
import selectPoint from "../components/common/selectPoint.vue";
import selectLine from "../components/common/selectLine.vue";
import lyGroup from "../../node_modules/common/src/components/lyGroup.vue";
import lyItem from "../../node_modules/common/src/components/lyItem.vue";
import tableForm from "../../node_modules/common/src/components/tableForm.vue";
import lyFormItem from "../../node_modules/common/src/components/lyFormItem.vue";
import lykanbanbox from "../../node_modules/common/src/components/lykanbanbox";
import selectTool from "../../node_modules/common/src/components/selectTool";
import lyList from "../../node_modules/common/src/components/lyList";
import axiosRes from "../../node_modules/common/src/components/axiosRes";
import lyMap from "../components/map/map";
import pointList from "../components/common/pointList";
import lineList from "../components/common/lineList";
import fenceList from "../components/common/fenceList";
import daoru from "../../node_modules/common/src/components/daoru";
import lyTable from "../../node_modules/common/src/components/lyTable.vue";
import selectDevice from "../components/common/selectDevice.vue";
import deviceTool from "../components/common/deviceTool.vue";
import lyPhoto from "../components/common/lyPhoto";
import startEnd from "../components/common/startEnd";
import selectAlotGroup from "../components/common/selectAlotGroup";
import searchAdd from "../components/common/searchAdd";
import blind from "../components/common/blind";
import lyyymmdd from "../../node_modules/common/src/components/lyyymmdd";
import showHide from "../components/common/showHide";
import lySearch from "../../node_modules/common/src/components/lySearch";
import formModel from "../../node_modules/common/src/components/formModel";
import imgList from "../../node_modules/common/src/components/imgList";

function plugins(Vue) {
  Vue.component("groupTree", groupTree);
  Vue.component("imgList", imgList);
  Vue.component("userTree", userTree);
  Vue.component("reportTop", reportTop);
  Vue.component("reportTools", reportTools);
  Vue.component("carTool", carTool);
  Vue.component("personTool", personTool);
  Vue.component("payTool", payTool);
  Vue.component("timeTool", timeTool);
  Vue.component("selectGroup", selectGroup);
  Vue.component("selectUser", selectUser);
  Vue.component("selectCar", selectCar);
  Vue.component("selectPerson", selectPerson);
  Vue.component("selectItems", selectItems);
  Vue.component("selectGrid", selectGrid);
  Vue.component("lyGroup", lyGroup);
  Vue.component("lyItem", lyItem);
  Vue.component("tableForm", tableForm);
  Vue.component("lyFormItem", lyFormItem);
  Vue.component("lykanbanbox", lykanbanbox);
  Vue.component("lyList", lyList);
  Vue.component("axiosRes", axiosRes);
  Vue.component("lyMap", lyMap);
  Vue.component("pointList", pointList);
  Vue.component("fenceList", fenceList);
  Vue.component("lineList", lineList);
  Vue.component("daoru", daoru);
  Vue.component("lyTable", lyTable);
  Vue.component("selectTool", selectTool);
  Vue.component("lyPhoto", lyPhoto);
  Vue.component("startEnd", startEnd);
  Vue.component("searchAdd", searchAdd);
  Vue.component("blind", blind);
  Vue.component("lySearch", lySearch);
  Vue.component("selectFence", selectFence);
  Vue.component("selectPoint", selectPoint);
  Vue.component("selectLine", selectLine);
  Vue.component("selecAlotCCar", selecAlotCCar);
  Vue.component("selectAlotGroup", selectAlotGroup);
  Vue.component("showHide", showHide);
  Vue.component("lyyymmdd", lyyymmdd);
  Vue.component("selectDevice", selectDevice);
  Vue.component("deviceTool", deviceTool);
  Vue.component("formModel", formModel);
}

export default plugins;



// WEBPACK FOOTER //
// ./src/util/person.js